import React from 'react';
import Tab from '../../_atoms/Tab';
import TabCountChip from '../../_atoms/TabCountChip'

function TabGroup({ children }) {
    return <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>{children}</div>;
}

export { TabGroup, Tab, TabCountChip };
